import { createFileRoute, notFound } from "@tanstack/react-router";
import { ComparePage, isCompareBrand } from "../../../features/compare";

/**
 * `/{lang}/compare/{brand}`: "MaJourneys vs GetYourGuide / Viator".
 * Any other brand slug is a real 404, not an empty comparison.
 */
export const Route = createFileRoute("/$lang/_layout/compare/$brand")({
  loader: ({ params }) => {
    if (!isCompareBrand(params.brand)) throw notFound();
  },
  component: ComparePage,
});
